<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import tdTheme from "./theme.json"; // 引入默认主题
import { mapState } from "vuex";

export default {
  name: "echart",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  // computed: {
  //   ...mapState("admin/theme", ["activeName"])
  // },
  data() {
    return {
      chart: null,
      activeName:""
    };
  },
  watch: {
    options: {
      handler(options) {
        if(options!=null){
        // 设置true清空echart缓存

        this.chart.setOption(options, true);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$echarts.registerTheme("tdTheme", tdTheme); // 覆盖默认主题
    this.initChart();
  },
  methods: {
    initChart() {
      // 初始化echart
      this.chart = this.$echarts.init(this.$el, this.activeName);
      this.chart.setOption(this.options, true);
    }
  }
};
</script>

<style>
</style>
